import { v4 as uuidv4 } from 'uuid';

export const generateUniqeId = () => {
    const id = uuidv4();
    return {
        type: 'GENERATE_UNIQUE_ID',
        payload: id
    };
};